module.exports = __webpack_public_path__ + "static/var1-690c52252867fcab29198cf8c4b9cdb1.jpg";